import type { $Fetch } from "ofetch";

/**
 * Nome do Controller da API
 */
const controller = "/guias";

/**
 * Classe de gerenciamento de chamadas da API dos Guias
 *
 * @class
 */
export default class GuiasApi {
    /**
     * Instância da dependência da API (ofetch)
     */
    private api;

    /**
     * Cria uma nova instância da classe GuiasApi.
     * @constructor
     * @param api - Instância da dependência da API (ofetch).
     */
    constructor(api: $Fetch) {
        this.api = api;
    }

    /**
  * @returns tipo de Guia
  */
    tipoGuia() {
        return this.api<ApplicationModule[]>(`${controller}/tipoguia`, {
            method: "GET",
        });
    }

    /**
* @returns Status Senha Autorização
*/
    statusSenhaAutorizacao() {
        return this.api<ApplicationModule[]>(`${controller}/statusSenhaAutorizacao`, {
            method: "GET",
        });
    }

    /**
* @returns Tipo Ausencia CodValidacao
*/
    tipoAusenciaCodValidacao() {
        return this.api<ApplicationModule[]>(`${controller}/tipoAusenciaCodValidacao`, {
            method: "GET",
        });
    }


    /**
     * @returns registro da guia
     * @param codGuia - Códico da Guia
     */
    lerRegistro(codGuia: number) {

        return this.api<ApplicationModule[]>(`${controller}/lerRegistro`, {
            method: "GET",
            params: { codGuia }
        });
    }


    /**
     * @returns Ler registro de Guia Pendente
     * @param codGuia - Código do Guia para buscar o registro pendente.
     */
    lerRegistroGuiaPendente(codGuia: number) {

        return this.api<ApplicationModule[]>(`${controller}/lerRegistroGuiaPendente`, {
            method: "GET",
            params: { codGuia }
        });
    }


    /**
     * Retorna o último número de Guia emitido para um Tipo de Guia de uma Operadora.
     * 
     * @param codOperadora - Código da Operadora.
     * @param codTipoGuia - Código do Tipo de Guia.
     * 
     * @returns Retorna o último número de Guia emitido.
     */
    listarUltimoNumeroGuia(codOperadora: number, codTipoGuia: number) {

        return this.api<ApplicationModule[]>(`${controller}/listarUltimoNumeroGuia`, {
            method: "GET",
            params: { codOperadora, codTipoGuia }
        });
    }


    /**
     * Verifica se um número de Guia existe na base de dados.
     * 
     * @param codOperadora - Código da Operadora.
     * @param codGuia - Código da Guia.
     * @param codTipoGuia - Código do Tipo de Guia.
     * @param numeroGuia - Número da Guia.
     * 
     * @returns Retorna true se o número da Guia existe e false caso contrário.
     */
    existeNumero(codOperadora: number, codGuia: number, codTipoGuia: number, numeroGuia: string) {

        return this.api<ApplicationModule[]>(`${controller}/existeNumero`, {
            method: "GET",
            params: { codOperadora, codGuia, codTipoGuia, numeroGuia }
        });
    }
}